import React from "react";
import { TreeviewDropdown } from '@softura/customcomponent';
import './TreeviewDropdown.scss';
interface Iprops {
    treeData: any,
    placeholder?: string,
    onSelect?: Function,
    maxHeight?: any,
    allowClear?: boolean,
    multiple?: boolean,
    showSearch?: boolean,
    filterTreeNode?: any,
    treeNodeFilterProp?: string,
    treeCheckable?: boolean,
    treeExpandedKeys?: any,
    className?: any,
    dropdownClassName?: any,
    selectAll?: any
    value?: any
    onChange?: any
    onDropdownVisibleChange?: any
    treeDefaultExpandAll?: any
    inputIcon?: any
    maxTagCount?: any
    treeDefaultExpandedKeys?: any
    treeLine?: boolean
    onBlur?: any
    disabled?: any,
    getPopupContainer?: any
    switcherIcon?:any
    tabIndex?:any
    onKeyDown?:any
}
const TreeviewDropdownContainer = ({
    treeData,
    placeholder,
    onSelect,
    maxHeight,
    allowClear,
    multiple,
    showSearch,
    filterTreeNode,
    treeNodeFilterProp,
    treeCheckable,
    treeExpandedKeys,
    className,
    dropdownClassName,
    selectAll,
    onChange,
    value,
    onDropdownVisibleChange,
    treeDefaultExpandAll,
    inputIcon,
    maxTagCount,
    treeDefaultExpandedKeys,
    treeLine,
    onBlur,
    disabled,
    getPopupContainer,
    switcherIcon,
    tabIndex,
    onKeyDown
}: Iprops) => {


    const options = selectAll ?
        [
            {
                title: 'Select All',
                value: "Select All",
                children: [
                    ...treeData
                ]
            }
        ] : [...treeData]

    return <TreeviewDropdown
        treeData={options}
        placeholder={placeholder}
        onSelect={onSelect}
        multiple={multiple}
        showSearch={showSearch}
        filterTreeNode={filterTreeNode}
        treeNodeFilterProp={treeNodeFilterProp}
        treeCheckable={treeCheckable}
        treeExpandedKeys={treeExpandedKeys}
        className={className}
        dropdownClassName={dropdownClassName}
        onChange={onChange}
        value={value}
        //onDropdownVisibleChange={onDropdownVisibleChangeOpen}
        treeDefaultExpandAll={treeDefaultExpandAll}
        allowClear={allowClear}
        inputIcon={inputIcon}
        maxTagCount={maxTagCount}
        treeDefaultExpandedKeys={treeDefaultExpandedKeys}
        treeLine={treeLine}
        onBlur={onBlur}
        disabled={disabled}
        key={tabIndex}
        switcherIcon={switcherIcon}
        tabIndex={tabIndex}
        onKeyDown={onKeyDown}
        getPopupContainer={function (trigger: Node) { return trigger.parentElement }}

    />
}

export default TreeviewDropdownContainer;